(function () {
    "use strict";

    angular.module("app.productDetail").factory("ProductDetailService", ProductDetailService);

    ProductDetailService.$inject = ["$http", "$q"];

    function ProductDetailService($http, $q) {
        var service = {
            getProduct : getProduct
        };

        return service;

        function getProduct(productId) {
			var deferred = $q.defer();
            var url = "/api/Product/";
			$http
				.get(url + productId)
				.then(getProductComplete)
				.catch(getProductFailed);

			function getProductComplete(response) {
				deferred.resolve(response);
			}

			function getProductFailed(error) {
				deferred.reject(error);
			}
			return deferred.promise;
		}
    }
})();
